import { useState, useEffect } from "react"
import { ContatoKeys, IContato } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { contatoKeyToLabel } from "../../../detalhes-do-projeto/filtros/contatos"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteContato = () => {
    // Redux State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    
    // Local State
    const [selectedContato, setSelectedContato] = useState<IContato[]>([])

    // Hooks
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        const contatosSelecionados = editRecorteExtracaoForm.fields.Filtros?.contato || [];

        if (contatosSelecionados.length > 0) {
            setSelectedContato(contatosSelecionados);
        } else {
            setSelectedContato([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.contato]);

    const filteredContato = ContatoKeys.filter((contato: IContato) =>
        !selectedContato.includes(contato)
    );

    const handleContatoSelectionChange = (value: IContato[]) => {
        setSelectedContato(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'contato',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'contato',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredContato}
                    value={selectedContato}
                    getOptionLabel={(option) => contatoKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    onChange={(event, value) => {
                        handleContatoSelectionChange(value);
                    }}
                    noOptionsText='Nenhum contato encontrado'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de tipos de contato"
                        />
                    )}
                    disableCloseOnSelect
                    filterSelectedOptions={true} 
                    renderOption={(props, option) => (
                        <li {...props}>
                            {contatoKeyToLabel(option).toUpperCase()}
                        </li>
                    )}
                />
            </Grid>
        </>
    )
}